import React, { Component } from 'react';
import PropTypes from 'prop-types';

import ProfessorGestorChecked from '../../assets/images/svg/professorCheck.svg';

class ProfessorGestorCheck extends Component {
  constructor(props) {
    super(props);
    this.state = {
      width: 24,
      height: 24,
    };
  }

  setState() {
    this.setState = {
      width: this.props.width,
      height: this.props.height,
    };
  }

  render() {
    return (
      <img
        src={ProfessorGestorChecked}
        width={this.state.width}
        height={this.state.height}
        className={this.props.className || ''}
        alt={'icone-gestor-check'}
        loading='lazy'
      />
    );
  }
}

ProfessorGestorCheck.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
};

export default ProfessorGestorCheck;
